var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 24,
    viewBox: "0 0 128 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 6.52793V4H65V17H74V14.3635H68.6462V11.4824H73.0997V8.95792H68.6462V6.52793H74Z",
    fill: "#4B286C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 14.4347H84.5657V4H81V17H90V14.4347Z",
    fill: "#4B286C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.29 9.12877C117.766 8.5533 116.884 8.48911 116.884 7.47507C116.884 6.5327 118.132 6.23911 118.853 6.23911C120.018 6.23911 121.39 6.51294 122.788 7.23953L123.805 4.79303C122.374 4.00187 120.533 3.67365 118.761 3.67365C115.28 3.67365 112.946 5.09938 112.851 7.88015C112.748 10.4146 114.79 11.3651 116.667 11.7569C118.474 12.1334 120.308 12.457 120.345 13.5423C120.379 14.5437 119.489 14.9721 117.808 14.9721C116.25 14.9721 114.804 14.4664 113.323 13.841L112.461 16.4986C114.159 17.2308 115.885 17.6328 117.666 17.6328C120.138 17.6328 121.94 17.2441 123.27 15.9842C124.19 15.1182 124.491 14.0736 124.491 13.0794C124.491 10.9769 123.196 9.79233 120.29 9.12877",
    fill: "#4B286C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.66 6.68571V4.06219H48.1846V6.68571H52.062V17.3574H55.7791V6.68571H59.66Z",
    fill: "#4B286C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.932 4.06207V12.5091C102.932 13.1706 102.932 13.3543 102.891 13.6113C102.774 14.4162 101.999 14.8834 100.767 14.8991C99.8555 14.8848 99.1882 14.6121 98.8766 14.1307C98.72 13.882 98.6444 13.4378 98.6444 12.728V4.06207H94.7676V13.2251C94.7676 14.4945 94.9353 15.0665 95.5007 15.7905C96.4382 16.9766 98.2632 17.598 100.776 17.598H100.856H100.911C104.277 17.598 106.012 16.2694 106.516 15.0304C106.767 14.4295 106.786 14.1435 106.786 12.93V4.06207H102.932",
    fill: "#4B286C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9364 0.421541L28.1904 4.79643V6.32751L28.2614 6.30976C42.6253 2.78207 49.9364 0.661691 49.9958 0.644996C50.0769 0.62408 50.1045 0.559893 50.094 0.506548C50.083 0.449077 50.0235 0.403312 49.9364 0.421541",
    fill: "#4B286C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H39.4197V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2562 0.00215289C31.1987 0.0638453 29.2419 1.64521 28.1683 2.58604C23.889 6.32539 20.7086 9.76405 18.3953 13.3645C13.5728 15.9728 7.42588 18.6568 1.32124 20.7527L1.17473 20.8025L0 24L0.67073 23.7374C4.55363 22.2425 11.0344 19.4349 16.9093 16.3131C16.5784 17.2046 16.4118 18.0234 16.4118 18.7709C16.4118 19.33 16.504 19.845 16.6892 20.3197C17.0594 21.2575 17.786 21.9698 18.7962 22.3758C20.2993 22.9824 22.3512 22.9941 24.6918 22.2781C30.6715 20.4443 37.7635 14.8238 39.3075 13.7064L39.3654 13.6636C39.4263 13.62 39.4308 13.5527 39.4041 13.508C39.3709 13.4571 39.3004 13.4444 39.2414 13.479L39.1659 13.5268C37.5082 14.5271 29.4564 19.359 24.2219 20.7792C21.5566 21.5016 19.5253 21.1059 18.7584 20.0226C18.4925 19.6536 18.3645 19.1845 18.3645 18.6374C18.3645 17.5735 18.8601 16.2149 19.8173 14.7078C20.6976 14.1995 21.5189 13.7043 22.259 13.2368C27.3666 10.3365 33.2496 4.69769 33.4994 1.25644C33.5009 1.23351 33.5009 1.20607 33.5009 1.17959C33.5009 0.884557 33.374 0.57667 33.151 0.3512C32.9123 0.10491 32.5961 -0.0180915 32.2562 0.00215289ZM31.6871 1.64358C32.023 1.4253 32.1197 1.56125 32.0215 1.8085C31.8603 2.20236 31.1252 4.58159 25.65 9.12189C24.2219 10.3049 23.2052 10.9705 21.1497 12.1988C24.5171 7.42904 29.4347 3.12275 31.6871 1.64358Z",
    fill: "#8DC63F"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1202 4.81093L5.24122 9.7801L4.35742 12.1828L28.1906 6.32772L28.228 6.31851V4.78857L28.1202 4.81093Z",
    fill: "#4B286C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 4,
    width: 3,
    height: 3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.25 4.06201H128V6.82647H125.25V4.06201Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.344 5.35132H126.604C126.823 5.35132 127.025 5.34019 127.025 5.08517C127.025 4.87102 126.841 4.8384 126.673 4.8384H126.344V5.35132ZM126.096 4.63442H126.713C127.094 4.63442 127.273 4.78601 127.273 5.09639C127.273 5.38854 127.09 5.51011 126.852 5.53601L127.31 6.24946H127.042L126.607 5.55491H126.344V6.24946H126.096V4.63442ZM126.629 6.62345C127.262 6.62345 127.752 6.11302 127.752 5.43632C127.752 4.77479 127.262 4.26503 126.629 4.26503C125.989 4.26503 125.499 4.77479 125.499 5.43632C125.499 6.11302 125.989 6.62345 126.629 6.62345V6.62345ZM126.629 4.06201C127.375 4.06201 128 4.65735 128 5.43632C128 6.23161 127.375 6.82647 126.629 6.82647C125.879 6.82647 125.25 6.23161 125.25 5.43632C125.25 4.65735 125.879 4.06201 126.629 4.06201V4.06201Z",
    fill: "#4B286C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelusLogo);
export default __webpack_public_path__ + "static/media/telus-logo.da1bf0893101bcd9f57075c0cfe48019.svg";
export { ForwardRef as ReactComponent };